import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    totalQuizzesPlayed: 0,
    totalImagesServed: 0,
    quizzesStatsArray: [],
    imagesStatsArray: []
}

export const fetchAdminData = createAsyncThunk(
    'admin/fetchAdminData',
    async (accessToken, thunkAPI) => {
        try {
            const adminDataPromise = await fetch( process.env.REACT_APP_DATABASE_URL + '/images', {
            method: 'GET',
            headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
            const adminData = await adminDataPromise.json();
            return adminData;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.message);
        }
    }
)

export const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        imageDeleted: (state, action) => {
            const temp_array = state.imagesStatsArray.filter(image => image.id !== parseInt(action.payload));
            state.imagesStatsArray = temp_array;
        },
        imageAdded: (state, action) => {
            state.imagesStatsArray.unshift(action.payload);
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchAdminData.pending, (state, action) => {
        })
        .addCase(fetchAdminData.fulfilled, (state, action) => {
            const adminData = action.payload;
            state.imagesStatsArray = adminData;
        })
        .addCase(fetchAdminData.rejected, (state, action) => {
        })
    }
})

export const {imageDeleted, imageAdded, updatePerformed} = adminSlice.actions;
export default adminSlice.reducer;
